import React, { Component } from "react";
import { withRouter } from "./withRouter";
import ReactMap, { Source, Layer } from "react-map-gl";
import { Box, Stack, Typography,ToggleButtonGroup,ToggleButton,Autocomplete,TextField } from "@mui/material";
import NZ2026HomeTooltip from "./NZ2026HomeTooltip"
import NZ2026SeatCompTooltip from "./NZ2026SeatCompTooltip"
import TooltipInternalMainMap from "./TooltipInternalMainMap"
import TooltipInternalHeatMap from "./TooltipInternalHeatMap"
const MAPBOX_TOKEN =
  "pk.eyJ1IjoibXppZW1pYW4iLCJhIjoiY2xhOXdpc2h5MDI1MzNxbG1wdzcxOWNlZSJ9.Km0c9-jUUlcBs6ByXYbYZA";


const MAP_STYLE = "mapbox://styles/mapbox/light-v11"; 

const possibleAreas = [
  { area_name: "Auckland Central", area_id: 1 },
  { area_name: "Banks Peninsula", area_id: 2 },
  { area_name: "Botany", area_id: 3 },
  { area_name: "Christchurch Central", area_id: 4 },
  { area_name: "Christchurch East", area_id: 5 },
  { area_name: "Coromandel", area_id: 6 },
  { area_name: "Dunedin", area_id: 7 },
  { area_name: "East Cape", area_id: 8 },
  { area_name: "East Coast Bays", area_id: 9 },
  { area_name: "Epsom", area_id: 10 },
  { area_name: "Glendene", area_id: 11 },
  { area_name: "Hamilton East", area_id: 12 },
  { area_name: "Hamilton West", area_id: 13 },
  { area_name: "Henderson", area_id: 14 },
  { area_name: "Hutt South", area_id: 15 },
  { area_name: "Ilam", area_id: 16 },
  { area_name: "Invercargill", area_id: 17 },
  { area_name: "Kaikōura", area_id: 18 },
  { area_name: "Kaipara ki Mahurangi", area_id: 19 },
  { area_name: "Kapiti", area_id: 20 },
  { area_name: "Kenepuru", area_id: 21 },
  { area_name: "Māngere", area_id: 22 },
  { area_name: "Manurewa", area_id: 23 },
  { area_name: "Maungakiekie", area_id: 24 },
  { area_name: "Mt Albert", area_id: 25 },
  { area_name: "Mt Maunganui", area_id: 26 },
  { area_name: "Mt Roskill", area_id: 27 },
  { area_name: "Napier", area_id: 28 },
  { area_name: "Nelson", area_id: 29 },
  { area_name: "New Plymouth", area_id: 30 },
  { area_name: "North Shore", area_id: 31 },
  { area_name: "Northcote", area_id: 32 },
  { area_name: "Northland", area_id: 33 },
  { area_name: "Ōtāhuhu", area_id: 34 },
  { area_name: "Pakuranga", area_id: 35 },
  { area_name: "Palmerston North", area_id: 36 },
  { area_name: "Papakura", area_id: 37 },
  { area_name: "Port Waikato", area_id: 38 },
  { area_name: "Rangitata", area_id: 39 },
  { area_name: "Rangitīkei", area_id: 40 },
  { area_name: "Remutaka", area_id: 41 },
  { area_name: "Rotorua", area_id: 42 },
  { area_name: "Selwyn", area_id: 43 },
  { area_name: "Southland", area_id: 44 },
  { area_name: "Taieri", area_id: 45 },
  { area_name: "Takanini", area_id: 46 },
  { area_name: "Tāmaki", area_id: 47 },
  { area_name: "Taranaki-King Country", area_id: 48 },
  { area_name: "Taupō", area_id: 49 },
  { area_name: "Tauranga", area_id: 50 },
  { area_name: "Tukituki", area_id: 51 },
  { area_name: "Upper Harbour", area_id: 52 },
  { area_name: "Waikato", area_id: 53 },
  { area_name: "Waimakariri", area_id: 54 },
  { area_name: "Wairarapa", area_id: 55 },
  { area_name: "Waitākere", area_id: 56 },
  { area_name: "Waitaki", area_id: 57 },
  { area_name: "Wellington Bays", area_id: 58 },
  { area_name: "Wellington North", area_id: 59 },
  { area_name: "West Coast-Tasman", area_id: 60 },
  { area_name: "Whanganui", area_id: 61 },
  { area_name: "Whangaparāoa", area_id: 62 },
  { area_name: "Whangārei", area_id: 63 },
  { area_name: "Wigram", area_id: 64 }
];

class MapComponent extends Component {


 

  render() {
    const { geoLevel, styledGeo, geoData, hoverInfo } = this.props;
    const { styleLoaded, selectedFeature } = this.props;


    return (
      <div style={{ height: "100%", width: "100%" }}>
        {selectedFeature?.name && (
          <div
            style={{
              position: "absolute",
              top: 12,
              left: 12,
              background: "rgba(255,255,255,0.95)",
              padding: "6px 10px",
              borderRadius: 6,
              fontFamily: "Inter, system-ui, sans-serif",
              fontSize: 13,
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <strong>Selected:</strong> {selectedFeature.name}
            <button
              onClick={() => this.setState({ selectedFeature: null })}
              style={{
                border: "none",
                background: "transparent",
                cursor: "pointer",
                fontSize: 16,
                lineHeight: 1,
                color: "#666",
                marginLeft: 6,
              }}
              aria-label="Clear selection"
              title="Clear selection"
            >
              
            </button>
          </div>
        )}

        <ReactMap
          ref={this.props.mapRef}
            initialViewState={{
                    bounds: [
                    [166.0, -47.5], // SW
                    [179.0, -33.0], // NE
                    ],
                    fitBoundsOptions: { padding: 40 }, // optional, gives margin
                }}
          style={{ width: "100%", height: "100%" }}
          projection={{ name: "mercator" }}
          mapStyle={MAP_STYLE}
          mapboxAccessToken={MAPBOX_TOKEN}
          interactiveLayerIds={["geo-fill"]}
            renderWorldCopies={true} // allow the map to repeat horizontally
          onClick={this.props.onMapClick}
          onMouseMove={this.props.onMouseMove}
          onLoad={this.onStyleLoad}
          viewState={this.props.viewState ? this.props.viewState : null}
        >
          {styleLoaded && (styledGeo || geoData)?.features && (
            <Source id="geo" type="geojson" data={styledGeo || geoData}>
              <Layer
                id="geo-fill"
                type="fill"
                paint={{
                  "fill-color": ["coalesce", ["get", "fillColor"], "#ffffff"],
                  "fill-opacity": ["case", ["has", "fillColor"], 0.75, 0],
                }}
              />
              <Layer
                id="geo-outline"
                type="line"
                paint={{
                  "line-color": "#111",
                  "line-width": 0.25,
                  "line-opacity": ["case", ["has", "fillColor"], 0.025, 0],
                }}
              />
              {selectedFeature?.level && (
                <Layer
                  id="geo-hover"
                  type="line"
                  paint={{
                    "line-color": "#ffffff",
                    "line-width": 2,
                  }}
                  filter={[
                    "==",
                    ["get",  "area_id"],
                    hoverInfo?.props?.["area_id"] || "",
                  ]}
                />
              )}
              <Layer
                id="geo-selected-halo"
                type="line"
                paint={{
                  "line-color": "#ffffff",
                  "line-width": 4,
                }}
                filter={
                  selectedFeature?.level === geoLevel && selectedFeature?.value
                    ? ["==", ["get", selectedFeature.key], selectedFeature.value]
                    : ["==", ["get", "__none__"], "__none__"]
                }
              />
              <Layer
                id="geo-selected"
                type="line"
                paint={{
                  "line-color": "#1976d2",
                  "line-width": 2,
                }}
                filter={
                  selectedFeature?.level === geoLevel && selectedFeature?.value
                    ? ["==", ["get", selectedFeature.key], selectedFeature.value]
                    : ["==", ["get", "__none__"], "__none__"]
                }
              />
            </Source>
          )}
          {hoverInfo && (
            this.props.tooltip === "home" ? (
                <NZ2026HomeTooltip
                hoverInfo={hoverInfo}
                geoData={geoData}
                styledGeo={styledGeo}
                geoLevel={geoLevel}
                
                tooltip_pastcomp={this.props.tooltip_pastcomp}
                />
            ) : this.props.tooltip === "seatcomp" ? (

                <NZ2026SeatCompTooltip
                hoverInfo={hoverInfo}
                geoData={geoData}
                styledGeo={styledGeo}
                chosenView = {this.props.chosenView}
                chosenParty = {this.props.chosenParty}
                geoLevel={geoLevel}
                tooltip_pastcomp={this.props.tooltip_pastcomp}
                />
              
              
            ) : this.props.tooltip ==="InternalMain" ?(
                <TooltipInternalMainMap
                hoverInfo={hoverInfo}
                geoData={geoData}
                styledGeo={styledGeo}
                chosenView = {this.props.chosenView}
                chosenParty = {this.props.chosenParty}
                geoLevel={geoLevel}
                tooltip_pastcomp={this.props.tooltip_pastcomp}
                />
              
            ) : this.props.tooltip === "InternalHeat" ? (

                              <TooltipInternalHeatMap
                hoverInfo={hoverInfo}
                geoData={geoData}
                styledGeo={styledGeo}
                chosenView = {this.props.chosenView}
                chosenParty = {this.props.chosenParty}
                geoLevel={geoLevel}
                tooltip_pastcomp={this.props.tooltip_pastcomp}
                />
            ): (null)
            )}

   {!this.props.smallMap &&(
           <Box
        sx={{
          position: "absolute",
          top: 16,
          left: 16,
          zIndex: 2,
          backgroundColor: "rgba(255,255,255,0.95)",
          borderRadius: 2,
          px: 2,
          paddingTop: 0.5,
          paddingBottom: 1.5,
          pointerEvents: "auto",
          boxShadow: 2
        }}
      >

     

        <Stack direction="row" sx={{
           display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        textAlign: "center",
        //flex: 1, 
        py:0,px:0,
        mb: 0.5}}>
        <Typography
          variant="caption"
          sx={{ display: "block",  color: "text.secondary" }}
        >
          Map Level
        </Typography>
        
              </Stack>

        <ToggleButtonGroup
          value={geoLevel}
          exclusive
          onChange={(e, newLevel) => {
            if (newLevel) this.props.onGeoLevelChange(newLevel);
          }}
          size="small"
        >
          <ToggleButton value="constituency">Electorate</ToggleButton>
          <ToggleButton value="SA3">SA3</ToggleButton>
          <ToggleButton value="SA2">SA2</ToggleButton>

        </ToggleButtonGroup>


      </Box>
   )}
   {!this.props.smallMap &&(

      <Box
        sx={{
          position: "absolute",
          top: 16,
          right: 16,
          zIndex: 2,
          backgroundColor: "rgba(255,255,255,0.95)",
          borderRadius: 2,
          px: 2,
          paddingTop: 0.5,
          paddingBottom: 1.5,
          pointerEvents: "auto",
          boxShadow: 2
        }}
      >

        <Stack direction="row" sx={{
           display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        textAlign: "center",
        //flex: 1, 
        py:0,px:0,
        mb: 0.5}}>
        <Typography
          variant="caption"
          sx={{ display: "block",  color: "text.secondary" }}
        >
          Choose and electorate to zoom in
        </Typography>
        
              </Stack>

         <Autocomplete
            disablePortal
              options={possibleAreas} // the array you passed up
              getOptionLabel={(option) => option.area_name}
            sx={{ width: "100%", mt:1.5, height:1 }}
            value={selectedFeature}
            renderInput={(params) => <TextField {...params} label="Find an area:"
                                                            size="small"             // <-- makes the input smaller
                                                            sx={{
                                                              "& .MuiInputBase-root": { height: 40 },  // adjust overall input height
                                                              "& .MuiOutlinedInput-input": { padding: "4px 8px" } // adjust inner text padding
                                                            }} />}
            onChange={(event, newValue) => {

             if (newValue === null) {
                this.props.resetView({LevelToResetTo:"constituency"})

               }else{
                  this.props.handleselectedFeatureChange(
                    {area_id:newValue?.area_id,area_name:newValue?.area_name}
                  );
                }

            }
          }
          />


      </Box>
        )}



        </ReactMap>
      </div>
    );
  }
}

export default withRouter(MapComponent);
